import React from "react";
import Field from "../Field";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { withStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const BogoField = ({ buyValue, getValue, classes }) => {
  const { t } = useTranslation();
  const renderByType = (tempType) => {
    switch (tempType) {
      case "center":
        return (
          <Grid
            container
            direction="row"
            alignItems="center"
            rowSpacing={1}
            columnSpacing={2}
          >
            <Grid size={{ xs: 12, sm: 3 }}>
              <Typography variant="body2" className={classes.value}>
                {buyValue}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <Typography variant="body2">
                {t("offer_create.basic_b_g_one_template")}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <Typography variant="body2" className={classes.value}>
                {getValue}
              </Typography>
            </Grid>
          </Grid>
        );
      default:
        return (
          <Grid
            container
            direction="row"
            alignItems="center"
            rowSpacing={1}
            columnSpacing={2}
          >
            <Grid size={{ xs: 12, sm: 2 }}>
              <Typography variant="body2">
                {t("offer_create.basic_b_one_prefix")}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Typography variant="body2" className={classes.value}>
                {buyValue}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 2 }}>
              <Typography variant="body2">
                {t("offer_create.basic_g_one_prefix")}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Typography variant="body2" className={classes.value}>
                {getValue}
              </Typography>
            </Grid>
          </Grid>
        );
    }
  };

  return (
    <Field
      title={t("offer_create.basic_b_g_one_label")}
      value={renderByType(t("offer_create.basic_b_g_template_type"))}
    />
  );
};

BogoField.propTypes = {
  buyValue: PropTypes.string.isRequired,
  getValue: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  value: {
    fontWeight: "bold",
  },
});

export default withStyles(styles)(BogoField);
